import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'

import { postOrdersWestfieldCorpAPI } from 'api/orders-westfieldcorp'
import { useOrdersStore } from 'store/ordersWestfieldCorp'
import { OrdersWestfieldCorpFetchParamsTypes } from 'types/orders-westfieldcorp'

import { DATASTATUS } from 'constants/status'

export const useOrders = () => {
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')
  const defaultParams = { traderId: memberTraderId }

  const ordersModStatus = useOrdersStore((state) => state.ordersModStatus)
  const ordersModStatusSet = useOrdersStore((state) => state.ordersModStatusSet)
  const ordersModErrors = useOrdersStore((state) => state.ordersModErrors)
  const ordersModErrorsSet = useOrdersStore((state) => state.ordersModErrorsSet)
  const orders = useOrdersStore((state) => state.orders)
  const ordersSet = useOrdersStore((state) => state.ordersSet)
  const [ordersFilterParams, ordersFilterParamsSet] =
    useState<OrdersWestfieldCorpFetchParamsTypes>(defaultParams)
  const [isOrdersFiltered, isOrdersFilteredSet] = useState<boolean>(false)

  const queryClient = useQueryClient()

  const { data, isLoading, isError, isSuccess } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useOrdersCorp', ordersFilterParams],
    queryFn: async () => {
      try {
        const response = await postOrdersWestfieldCorpAPI(ordersFilterParams)
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        return response.data
      } catch (e) {
        ordersModErrorsSet(JSON.stringify(e))
      }
    },
  })

  const handleFilter = useCallback(
    async (filterParams: OrdersWestfieldCorpFetchParamsTypes) => {
      ordersFilterParamsSet(filterParams)
      isOrdersFilteredSet(true)
    },
    [ordersFilterParamsSet, isOrdersFilteredSet]
  )

  const handleUnfilter = useCallback(() => {
    const test = { traderId: memberTraderId }
    ordersFilterParamsSet(test)
    isOrdersFilteredSet(false)
  }, [ordersFilterParamsSet, isOrdersFilteredSet])

  return {
    memberHandleOrdersFilter: handleFilter,
    memberHandleOrdersUnfilter: handleUnfilter,
    data,
    isLoading,
    isError,
    isSuccess,
  }
}
